import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import React from "react";
export var ExternalDocumentFrame = function(param) {
    var documentLink = param.documentLink;
    React.useEffect(function() {
        // We want to redirect to the external link on mobile apps since iframes do not behave nicely
        if (isMobileApp()) {
            getLocationOrThrow().href = documentLink;
        }
    }, [
        documentLink
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            height: "100vh"
        },
        children: [
            /*#__PURE__*/ _jsx("iframe", {
                src: documentLink,
                width: "100%",
                height: "100%",
                frameBorder: "0",
                allowFullScreen: false,
                allow: "autoplay"
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
